import styled from 'styled-components';

export const FloatingWhatsApp = styled.a`
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  background-color: unset;
  border-radius: 0;

  &:hover {
    background-color: unset;
    transform: scale(1.05);
    transition: transform 0.2s ease-in-out;
  }

  img {
    width: 60px;
    height: 60px;
  }
`;
